import { Navigate } from "react-router-dom";
import { useVisibleNav } from "./Layout";

// "/" is not a page of its own: it sends the login to the first page it can
// actually open. Workshop Analytics is the preferred landing page; Overview
// is just another nav item, and a brand that has switched it off in Feature
// access should never land on it.
const PREFERRED = "/analytics";

export default function LandingRoute() {
  const nav = useVisibleNav();
  const target = nav.find((item) => item.to === PREFERRED) || nav[0];

  if (!target) {
    return (
      <p className="text-[14px] text-[#6B7280]" data-testid="no-pages-enabled">
        No pages are enabled for this account.
      </p>
    );
  }
  return <Navigate to={target.to} replace />;
}
